import RMSvgIcon from 'components/customComponents/CommonComponents/RMSvgIcon';
import React from 'react';

type AlertType = 'error' | 'warning' | 'success' | 'info';

interface AlertProps {
  type?: AlertType;
  title: string;
  message: string;
}

const typeConfig: Record<
  AlertType,
  { bg: string; text: string; icon: any; fill: string }
> = {
  error: { bg: 'bg-red-100', text: 'text-[#FF5252]', icon: 'Warning', fill: '#FF5252' },
  warning: {
    bg: 'bg-yellow-100',
    text: 'text-yellow-600',
    icon: 'Warning',
    fill: '#F59E0B',
  },
  success: { bg: 'bg-green-100', text: 'text-green-600', icon: 'Check', fill: '#10B981' },
  info: { bg: 'bg-blue-100', text: 'text-blue-600', icon: 'Info', fill: '#3B82F6' },
};

export default function AlertBoxBody({ type = 'info', title, message }: AlertProps) {
  const config = typeConfig[type];

  return (
    <div id='commandpanel-importdoe-alertboxbody-wrapper' className="flex flex-col w-full max-w-md gap-3 rounded-md items-center">
      <div id='commandpanel-importdoe-alertboxbody-configbg'
        className={`flex w-full items-center justify-center rounded-md px-3 py-2 ${config.bg}`}
      >
        <div id='commandpanel-importdoe-alertboxbody-configfill' className="flex flex-row items-center gap-2 w-full">
          <RMSvgIcon id='commandpanel-importdoe-alertboxbody-configfill-icon' name={config.icon} width={20} height={20} fill={config.fill} />
          <span id={`commandpanel-importdoe-alertboxbody-config-${title}`} className={`${config.text} text-[0.75rem] font-medium`}>{title}</span>
        </div>
      </div>
      <p id={`commandpanel-importdoe-alertboxbody-config-message`} className="w-full text-sm text-gray-600 leading-snug text-center sm:text-left">
        {message}
      </p>
    </div>
  );
}
